import { TResolvedVersion } from '../types';

/**
 * Resolve URL for Comgate Checkout script
 * @param cdnBaseUrl
 * @param version
 * @param file
 */
export const resolveFileUrl = (cdnBaseUrl: string, version: TResolvedVersion, file?: string): string => {
    return `${cdnBaseUrl + version.version}${resolveFileName(version, file)}`;
};

/**
 * Resolve the file name based on version, hash and optional file name
 * @param version
 * @param file
 */
const resolveFileName = (version: TResolvedVersion, file?: string): string => {
    if (file && file.length > 0) {
        return '/' + expandFileName(file, version.hash);
    }
    return '';
};

/**
 * Expand the file name by appending the hash if available
 * @param file
 * @param hash
 */
const expandFileName = (file: string, hash: string | null | undefined): string => {
    if (hash) {
        const lastDot = file.lastIndexOf('.');
        if (lastDot >= 0) {
            const name = file.slice(0, lastDot);
            const ext = file.slice(lastDot);
            return `${name}.${hash}${ext}`;
        }
    }
    return file;
};
